import { render, staticRenderFns } from "./PrivacyPolicyCpt.vue?vue&type=template&id=76f63e6d&scoped=true&"
import script from "./PrivacyPolicyCpt.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyCpt.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyCpt.vue?vue&type=style&index=0&id=76f63e6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f63e6d",
  null
  
)

export default component.exports